import { action } from 'satcheljs';

export interface DELETE_FOLDER_STORE_UPDATEActionMessage {
    folderIds: string[];
    groupId: string | undefined;
}
const defaultExport: (
    folderIds: string[],
    groupId?: string
) => DELETE_FOLDER_STORE_UPDATEActionMessage = action(
    'DELETE_FOLDER_STORE_UPDATE',
    (folderIds: string[], groupId?: string): DELETE_FOLDER_STORE_UPDATEActionMessage => {
        return {
            folderIds,
            groupId,
        };
    }
);
export default defaultExport;
